const protectedPaths = new Set(['/', '/organization/companies', '/organization/users', '/organization/roles', '/organization/audit', '/identity/entra', '/identity/welcome', '/identity/welcome/personnel', '/communication/channels', '/communication/templates', '/communication/transactions', '/integration/secrets', '/integration/connections', '/integration/keys', '/infrastructure/regions'])

/** A return hint can only resume a known Console page, never an auth/API URL. */
export function consoleReturnPath(value: unknown): string | undefined {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || /[\\\u0000-\u001f\u007f]/.test(value)) return
  try {
    const url = new URL(value, 'https://console.invalid')
    if (url.origin === 'https://console.invalid' && (protectedPaths.has(url.pathname) || /^\/communication\/(?:channels|templates)\/[a-f\d]{24}$/i.test(url.pathname))) return `${url.pathname}${url.search}${url.hash}`
  } catch { /* An invalid optional return hint falls back to the Console home. */ }
}

export function consoleLoginLocation(fullPath?: string) {
  const returnTo = consoleReturnPath(fullPath)
  return { name: 'login' as const, ...(returnTo && returnTo !== '/' ? { query: { returnTo } } : {}) }
}
